
import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate, deletedata } from "../../util/global";

import ZohoConfigForm from './ZohoConfigForm';
import AmazonConfigForm from './AmazonConfigForm';
import SettingForm from './SettingForm';

const KitstersSetting = () => {
  const [zohoconfig, setzohoconfig] = useState({});
  const [amazonconfig, setamazonconfig] = useState({});
  const [usersetting, setusersetting] = useState({});

  const [showmodal, setshowmodal] = useState(false);

  const fetchdata = async () => {
    try {
      let z = await getdata({filter:{"datatype":"zohoconfigdata"}});
      if (z.length > 0)   
        setzohoconfig(z[0]);

      let a = await getdata({filter:{"datatype":"amazonconfigdata"}});
      if (a.length > 0) {
        setamazonconfig(a[0]);
      }

      let u = await getdata({filter:{"datatype":"usersettingdata"}});
      if (u.length > 0) {
        setusersetting(u[0]);
      }
      console.log(amazonconfig, zohoconfig);
    } catch (err) { console.error(err); }
  };


  const openzohoconfigform = () => {
    setshowmodal("showzohoconfigform");
  };
  
  const openamazonconfigform = () => {
    setshowmodal("showamazonconfigform");
  };

  const openusersettingform = () => {
    setshowmodal("showusersettingform");
  };

  const updatezohoconfig = async () => {

    try {
      zohoconfig.config = JSON.parse(JSON.stringify(zohoconfig.config));
    } catch (ex) {
      console.log(ex);
      alert("invalid json");
      return false;
    }
    zohoconfig.datatype = "zohoconfigdata";
    let payload = {data:zohoconfig};

    console.log(payload);    
    const result = await updatedata(payload);
    fetchdata();
    setshowmodal(false);
  };

  const updateamazonconfig = async () => {

    try {
      amazonconfig.config = JSON.parse(JSON.stringify(amazonconfig.config));
    } catch (ex) {
      console.log(ex);
      alert("invalid json");
      return false;
    }
    amazonconfig.datatype = "amazonconfigdata";
    let payload = {data:amazonconfig};

    console.log(payload);    
    const result = await updatedata(payload);
    fetchdata();
    setshowmodal(false);
  };

  const updateusersetting = async () => {
    try {
      usersetting.config = JSON.parse(JSON.stringify(usersetting.config));
    } catch (ex) {
      console.log(ex);
      alert("invalid json");
      return false;
    }
    usersetting.datatype = "usersettingdata";
    let payload = {data:usersetting};

    console.log(payload);    
    const result = await updatedata(payload);
    fetchdata();
    setshowmodal(false);
  };


  useEffect(() => { fetchdata(); }, []);
  

  return (
    <>
    <div className="content-area">

      <a href={"#"} onClick={(e) => {openzohoconfigform();}}>Zoho Config</a>
      <ZohoConfigForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        zohoconfig={zohoconfig} 
        updatezohoconfig={updatezohoconfig}  
        setzohoconfig={setzohoconfig}    
      />
    </div>
    <div className="content-area">

      <a href={"#"} onClick={(e) => {openamazonconfigform();}}>Amazon Config</a>
      <AmazonConfigForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        amazonconfig={amazonconfig} 
        updateamazonconfig={updateamazonconfig}  
        setamazonconfig={setamazonconfig}    
      />
    </div>
    <div className="content-area">

      <a href={"#"} onClick={(e) => {openusersettingform();}}>User Setting</a>
      <SettingForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        config={usersetting} 
        updateconfig={updateusersetting}  
        setconfig={setusersetting}
        title="User Setting"
      />
    </div>
    </>
  );
};

export default KitstersSetting;